import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/logo-run.png'


const _withScopeId = n => (_pushScopeId("data-v-7b2bfc7c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "run-activity bx" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "start" }, "点击打卡", -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "btn already"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "start" }, "已打卡", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 2,
  class: "over"
}
const _hoisted_10 = { class: "card" }
const _hoisted_11 = {
  key: 0,
  class: "day fl"
}
const _hoisted_12 = { class: "top" }
const _hoisted_13 = { class: "num" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 天 ")
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bottom" }, "累计打卡目标", -1))
const _hoisted_16 = {
  key: 1,
  class: "day fl"
}
const _hoisted_17 = {
  key: 0,
  class: "top"
}
const _hoisted_18 = { class: "num" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" 天 ")
const _hoisted_20 = {
  key: 1,
  class: "top"
}
const _hoisted_21 = { class: "num" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" 天 ")
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bottom" }, "打卡目标", -1))
const _hoisted_24 = {
  key: 2,
  class: "person fl"
}
const _hoisted_25 = { class: "top" }
const _hoisted_26 = { class: "num" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" 人 ")
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bottom" }, "活动参加人数", -1))
const _hoisted_29 = {
  key: 3,
  class: "person fl"
}
const _hoisted_30 = { class: "top" }
const _hoisted_31 = { class: "num" }
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" 人 ")
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bottom" }, "累计打卡人数", -1))
const _hoisted_34 = {
  key: 4,
  class: "person fl"
}
const _hoisted_35 = { class: "top" }
const _hoisted_36 = { class: "num" }
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" 人 ")
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bottom" }, "坚持打卡人数", -1))
const _hoisted_39 = {
  key: 5,
  class: "time fr"
}
const _hoisted_40 = { class: "top" }
const _hoisted_41 = { class: "num" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "天", -1))
const _hoisted_43 = { class: "num" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "小时", -1))
const _hoisted_45 = { class: "num" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "分", -1))
const _hoisted_47 = { class: "num" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "秒", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bottom" }, "截止报名时间", -1))
const _hoisted_50 = { class: "sign-time" }
const _hoisted_51 = { class: "time-box" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "name" }, "打卡开始时间", -1))
const _hoisted_53 = { class: "time" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hr" }, null, -1))
const _hoisted_55 = { class: "time-box" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "name" }, "打卡结束时间", -1))
const _hoisted_57 = { class: "time" }
const _hoisted_58 = ["innerHTML"]

import PostMenu from '../components/PostMenu.vue';
import MoveActive from '../components/MoveActive.vue';
import { ref, onMounted, watch } from 'vue';
import PostDetail from '@/components/PostDetail.vue';
import Switch from '@/components/Switch.vue';
import { ActivityFetch } from '@/api/request';
import { useRouter } from 'vue-router';
import { ICircleInfoProps, IClockTaskProps, PaginationProps } from '@/api/type';
import config from '../_config';
import { format, formatEmotions, formatWrap } from '@/lib';
import { Toast } from 'vant';
import axios from 'axios';
import RankList from '../components/RankList.vue';
import SignList from '../components/SignList.vue';

import Release from '@/components/release/index.vue';
import RunRelease from '@/components/release/runIndex.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();
const active = ref(0);
const switchAll = ref(true);
const taskIds = router?.currentRoute?.value?.query?.taskId;
const taskId = Array.isArray(taskIds) ? (taskIds[0] as string) : taskIds || '';
const actDetail = ref<IClockTaskProps>();
const countdownTime = ref<number>(0);
const record = ref<number>(0);
const userId = window.localStorage.getItem('userId') || '';
const loading = ref(false);
const finished = ref(false);

// 打卡相关
const show = ref(false);
const showRun = ref(false);
const type = ref('');
const contentFlag = ref('');
const actInfo = {
  socialCircleType: null,
  markTaskType: null,
  taskEnrollId: null,
  taskId: null,
  subType: null
};

const list = ref<ICircleInfoProps[]>([]);
const detailInfo = ref<string>();
const pagination = ref<PaginationProps>({
  pageNum: 0,
  pageSize: 5
});

const showPost = () => {
  // 2: 读书 3：运动 4: 其他
  if (actInfo.markTaskType === 2) {
    console.log('读书');
    type.value = '2';
    show.value = true;
  } else if (actInfo.markTaskType === 3) {
    showRun.value = true;
  } else {
    console.log('其他');
    showRun.value = true;
  }
};

const onLoad = async() => {
  // 异步更新数据
  loading.value = true;

  pagination.value.pageNum += 1;
  console.log(actDetail.value);
  const params = {
    pageNum: pagination.value.pageNum,
    pageSize: pagination.value.pageSize,
    htId: actDetail.value.topicId,
    taskId,
    userId: switchAll.value ? '' : userId
  };
  const res = await ActivityFetch.selCircleDynamicInfos(params);
  const body = res.body;
  if (Array.isArray(body)) {
    body.forEach((item, index) => {
      // 超过100文字裁剪
      item.showText2 = false;
      if (typeof item.scText === 'string') {
        if (item.scText.length > 100) {
          item.scText2 = item.scText.substring(0, 100);
          item.showText2 = true;
        }
      }

      item.scText = formatWrap(item.scText);
      item.scText = formatEmotions(item.scText);

      item.scText2 = formatWrap(item.scText2);
      item.scText2 = formatEmotions(item.scText2);
      // 图片地址集合分割成数组
      if (item.scPicUrl) {
        item.picUrl = item.scPicUrl.split(',');
      } else {
        item.picUrl = [];
      }
      if (Array.isArray(item.praiseList)) {
        item.praiseList = item.praiseList.slice(0, 4);
      }

      // 只有 scType === -3 extContent 才会有信息
      try {
        item.extContent = JSON.parse(item.extContent);
      } catch (e) {
        item.extContent = null;
      }
    });

    list.value = list.value.concat(body);
    // 加载状态结束
    loading.value = false;
    // 到底了
    if (body.length === 0 || body.length < pagination.value.size) {
      finished.value = true;
    }
  }
  if (!body) {
    finished.value = true;
  }
};

const init = async() => {
  const res = await ActivityFetch.getActDetail({ taskId, newVersion: '1' });
  if (res.code === '00') {
    actDetail.value = res.body;
    onLoad();
    actInfo.socialCircleType = actDetail.value.socialCircleType;
    actInfo.markTaskType = actDetail.value.markTaskType;
    actInfo.taskEnrollId = actDetail.value.taskEnrollId;
    actInfo.initiatorUserId = actDetail.value.initiatorUserId;
    actInfo.taskId = actDetail.value.id;
    actInfo.subType = actDetail.value.markTaskType === 2 ? 1 : 2;
    contentFlag.value = '#' + res.body.topicName + '#';
    console.log(contentFlag.value, 'contentFlag.value');

    countdownTime.value = res.body.enrollEndTime - new Date().getTime();
    const resourcesUrl = res.body.taskDetailJsonUrl;
    axios.get(config.articleUrl + resourcesUrl).then((resJson) => {
      if (resJson.data.indexOf('=') !== -1) {
        const content = resJson.data.slice(resJson.data.indexOf('=') + 1);
        detailInfo.value = content;
      }
    });
    if (res.body.status !== 1) {
      const recordRes = await ActivityFetch.selClockTaskRecords({
        taskId
      });
      console.log(recordRes);
      record.value = recordRes.body || 0;
    }
  }
};

const toEnroll = async() => {
  const res = await ActivityFetch.usTaskClockEnroll({
    taskId: taskId,
    channelType: 2
  });
  if (res.code === '00' && res.body) {
    Toast('参加成功!');
    init();
  }
};

watch(
  () => switchAll.value,
  () => {
    list.value = [];
    pagination.value = {
      pageNum: 0,
      pageSize: 5
    };
    onLoad();
  },
  { immediate: true }
);
watch(
  () => switchAll.value,
  () => {
    list.value = [];
    pagination.value = {
      pageNum: 0,
      pageSize: 5
    };
    init();
  },
  { immediate: true }
);
onMounted(() => {});

return (_ctx: any,_cache: any) => {
  const _component_van_count_down = _resolveComponent("van-count-down")!
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PostMenu),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "bg",
        style: _normalizeStyle({
          backgroundImage:
            'url(' + _unref(config).articleUrl + actDetail.value?.bigBackGroupUrl + ')'
        })
      }, [
        (
            actDetail.value?.status === 3 &&
            actDetail.value.ifEnroll > 0 &&
            actDetail.value.ifMark !== 1
          )
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "btn",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (showPost()))
            }, _hoisted_5))
          : (
            actDetail.value?.status === 3 &&
            actDetail.value.ifEnroll > 0 &&
            actDetail.value.ifMark === 1
          )
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
            : _createCommentVNode("", true),
        (actDetail.value?.status === 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, "活动即将开始"))
          : _createCommentVNode("", true)
      ], 4),
      _createElementVNode("div", _hoisted_10, [
        (actDetail.value?.cycleType === 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("span", _hoisted_13, _toDisplayString(actDetail.value?.days), 1),
                _hoisted_14
              ]),
              _hoisted_15
            ]))
          : _createCommentVNode("", true),
        (actDetail.value?.cycleType === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              (actDetail.value?.status === 3 || actDetail.value?.status === 4)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createElementVNode("span", _hoisted_18, _toDisplayString(actDetail.value?.maskDays || '0') + "/" + _toDisplayString(actDetail.value?.days), 1),
                    _hoisted_19
                  ]))
                : _createCommentVNode("", true),
              (actDetail.value?.status === 1 || actDetail.value?.status === 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _createElementVNode("span", _hoisted_21, _toDisplayString(actDetail.value?.days), 1),
                    _hoisted_22
                  ]))
                : _createCommentVNode("", true),
              _hoisted_23
            ]))
          : _createCommentVNode("", true),
        (actDetail.value?.status === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("span", _hoisted_26, _toDisplayString(actDetail.value?.visitors), 1),
                _hoisted_27
              ]),
              _hoisted_28
            ]))
          : _createCommentVNode("", true),
        (actDetail.value?.status === 3 && actDetail.value?.cycleType === 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("span", _hoisted_31, _toDisplayString(actDetail.value?.seriesPeopleNums || 0), 1),
                _hoisted_32
              ]),
              _hoisted_33
            ]))
          : _createCommentVNode("", true),
        (
            (actDetail.value?.status === 4 || actDetail.value?.status === 3) &&
            actDetail.value?.cycleType === 1
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("span", _hoisted_36, _toDisplayString(actDetail.value?.seriesPeopleNums), 1),
                _hoisted_37
              ]),
              _hoisted_38
            ]))
          : _createCommentVNode("", true),
        (actDetail.value?.status === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _createVNode(_component_van_count_down, {
                  time: countdownTime.value,
                  class: "count-down"
                }, {
                  default: _withCtx((timeData) => [
                    _createElementVNode("span", _hoisted_41, _toDisplayString(timeData.days <= 9 ? '0' + timeData.days : timeData.days), 1),
                    _hoisted_42,
                    _createElementVNode("span", _hoisted_43, _toDisplayString(timeData.hours <= 9 ? '0' + timeData.hours : timeData.hours), 1),
                    _hoisted_44,
                    _createElementVNode("span", _hoisted_45, _toDisplayString(timeData.minutes <= 9
                    ? '0' + timeData.minutes
                    : timeData.minutes), 1),
                    _hoisted_46,
                    _createElementVNode("span", _hoisted_47, _toDisplayString(timeData.seconds <= 9
                    ? '0' + timeData.seconds
                    : timeData.seconds), 1),
                    _hoisted_48
                  ]),
                  _: 1
                }, 8, ["time"])
              ]),
              _hoisted_49
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_50, [
        _createElementVNode("div", _hoisted_51, [
          _hoisted_52,
          _createElementVNode("div", _hoisted_53, _toDisplayString(_unref(format)(actDetail.value?.startTime, 'YYYY年MM月DD日 hh:mm')), 1)
        ]),
        _hoisted_54,
        _createElementVNode("div", _hoisted_55, [
          _hoisted_56,
          _createElementVNode("div", _hoisted_57, _toDisplayString(_unref(format)(actDetail.value?.endTime, 'YYYY年MM月DD日 hh:mm')), 1)
        ])
      ]),
      _createVNode(_component_van_tabs, {
        active: active.value,
        "onUpdate:active": _cache[1] || (_cache[1] = ($event: any) => ((active).value = $event)),
        shrink: ""
      }, {
        default: _withCtx(() => [
          (actDetail.value?.status !== 1)
            ? (_openBlock(), _createBlock(_component_van_tab, {
                key: 0,
                title: "打卡排行榜"
              }, {
                default: _withCtx(() => [
                  _createVNode(RankList)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_van_tab, { title: "打卡介绍" }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                innerHTML: detailInfo.value,
                class: "detail-card"
              }, null, 8, _hoisted_58)
            ]),
            _: 1
          }),
          (actDetail.value?.status === 1)
            ? (_openBlock(), _createBlock(_component_van_tab, {
                key: 1,
                title: "报名人数"
              }, {
                default: _withCtx(() => [
                  _createVNode(SignList)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (actDetail.value?.ifEnroll as number <= 0 && actDetail.value?.status === 1)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "btn",
                onClick: toEnroll
              }, " 参与挑战 "))
            : ((actDetail.value?.ifEnroll as number >= 1) && actDetail.value?.status === 1)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 3,
                  class: "btn success",
                  onClick: toEnroll
                }, " 报名成功 "))
              : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["active"])
    ]),
    _createVNode(MoveActive, {
      type: actDetail.value?.markTaskType === 3 ? '2' : '3'
    }, null, 8, ["type"]),
    _createVNode(Release, {
      onCancel: _cache[2] || (_cache[2] = ($event: any) => (show.value = false)),
      show: show.value,
      type: type.value,
      actInfo: actInfo,
      contentFlag: contentFlag.value
    }, null, 8, ["show", "type", "contentFlag"]),
    _createVNode(RunRelease, {
      contentFlag: contentFlag.value,
      onCancel: _cache[3] || (_cache[3] = ($event: any) => (showRun.value = false)),
      show: showRun.value,
      actInfo: actInfo
    }, null, 8, ["contentFlag", "show"])
  ]))
}
}

})